export { default as StrategyResultsHeader } from './StrategyResultsHeader';
